/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ClientState} from "./clientState.zod";
import {ContactDto} from "./contactDto.zod";
import {HeliportEnvironment} from "./heliportEnvironment.zod";
import {NoteDto} from "./noteDto.zod";
import {RegisteredCompanyDto} from "./registeredCompanyDto.zod";

export const ClientDto = zod.object({
  clientId: zod.uuid(),
  state: ClientState,
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  company: RegisteredCompanyDto,
  environments: zod.array(HeliportEnvironment).min(1),
  logoUrl: zod.string().nullable(),
  contacts: zod.array(ContactDto),
  notes: zod.array(NoteDto),
});

export type ClientDto = zod.input<typeof ClientDto>;
export type ClientDtoOutput = zod.output<typeof ClientDto>;
